import QRCode from "qrcode";

export const generateQRBase64 = async (text) => {
  try {
    return await QRCode.toDataURL(text);
  } catch (err) {
    console.error("Error generando QR:", err);
    return "";
  }
};
export const formatCodigoCotizacion = (codigo) => {
  if (!codigo) return "2026-0000";
  const sczIndex = codigo.indexOf("SCZ");

  if (sczIndex === -1) {
    const match = codigo.match(/^(\d{2})([A-Za-z]*)(\d+)$/);
    if (match) {
      const año = match[1]; // "26"
      const numero = match[3]; // "0005"
      const añoCompleto = `20${año}`;
      return `${añoCompleto}-${numero.padStart(4, "0")}`;
    }
    return codigo;
  }

  const año = codigo.substring(0, sczIndex); // "26"
  const numero = codigo.substring(sczIndex + 3); // "0005"

  const añoCompleto = `20${año}`; // "2026"

  const numeroFormateado = numero.padStart(4, "0");

  return `${añoCompleto}-${numeroFormateado}`;
};

export const formatCodigoInterno = (codigo) => {
  if (!codigo) return "SCZ-2026-0000";

  const sczIndex = codigo.indexOf("SCZ");

  if (sczIndex === -1) {
    return codigo;
  }

  const año = codigo.substring(0, sczIndex);
  const numero = codigo.substring(sczIndex + 3);

  const añoCompleto = `20${año}`;
  const numeroFormateado = numero.padStart(4, "0");

  return `SCZ-${añoCompleto}-${numeroFormateado}`;
};

export function formattedValue(numberString) {
  if (numberString && numberString.includes("/")) {
    const [month, year] = numberString.split("/");
    const fullYear = "20" + year;
    const sequenceNumber = String(month).padStart(3, "0");
    return `SCZ-${fullYear}-${sequenceNumber}`;
  }
  return numberString;
}
export function formattedValueNumber(numberString) {
  if (numberString && numberString.includes("/")) {
    const [month, year] = numberString.split("/");
    const fullYear = "20" + year;
    const sequenceNumber = String(month).padStart(3, "0");
    return `${fullYear}-${sequenceNumber}`;
  }
  return numberString;
}
